import { Permission } from "@communicare/medications/Config/PermissionConfig";
import { createContext } from "react";
import {UserType} from '../../services/medicationmanagement/medsUser/MedsUserApi';


export interface UserInfo{
        email: string;
        userName:string;
        familyName:string;
        givenName:string;
        permissions:Permission[],
        userType:UserType|null,
        signIn:any;
        isShared: boolean,
        signOut:any;
        userId:string;
}

export interface UserIdentity{
    userInfo:UserInfo|null; 
    setUserInfo: (val:UserInfo)=>void
}

export const IdentityContext = createContext<UserIdentity|null>(null)